import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import SearchButton from "../../../../components/SearchButton";
import RefreshButton from "../../../../components/RefreshButton";

const TableFilters = ({
  setIsSearching,
  setFilterText,
  moduleDetails,
  textInputName,
  disabledButton,
}) => {
  const [inputValue, setInputValue] = useState("");

  const FilterData = () => {
    setFilterText(inputValue);
  };
  const DoNothing = () => {};
  return (
    <div>
      <div className="flex flex-row space-x-2">
        <TextInput
          type={textInputName}
          name={textInputName}
          value={inputValue}
          placeholder={moduleDetails}
          onChange={(e) => {
            setInputValue(e.target.value);
            e.target.value === "" ? setFilterText("") : DoNothing();
          }}
        />

        <SearchButton
          buttonValue="Search"
          className={
            inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
          }
          disabled={inputValue === "" || disabledButton ? true : false}
          onClick={() => {
            FilterData();
            setIsSearching(true);
          }}
        />
        <div>
          <RefreshButton
            className={
              inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
            }
            disabled={inputValue === "" || disabledButton ? true : false}
            onClick={() => {
              if (!disabledButton) {
                setFilterText("");
                setInputValue("");
              }
              setIsSearching(false);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
